// extracted by mini-css-extract-plugin
export default {"hero":"TheHero_hero__DbTlS","hero__content":"TheHero_hero__content__tKVWV","hero__body":"TheHero_hero__body__qDysn"};